<template>
  <main class="c-pagedesigner page-designer-reference main-content main-content--mobile page" id="main-content" style="padding-top: 0px">
    <div class="col-12 px-2 c-strat__container">
      <div class="experience-component experience-layouts-1column">
        <div style="">
          <div class="experience-region experience-column1">
            <div class="experience-component experience-assets-strat2">
              <div class="c-strat2 c-background js_strat layout layout--full-width" style="">
                <div class="c-strat2__main-image c-background__content-wrapper js_strat_main_image null">
                  <div class="layout">
                    <div class="c-background__content">
                      <div class="ms-row center-xs">
                        <div class="col-xs-10 col-md-6">
                          <div class="c-strat2__title-wrapper">
                            <span class="c-strat2__title" style="color: null">
                              <h2><span style="color: rgb(0, 0, 0)">永续美丽</span></h2>
                            </span>
                            <span class="c-strat2__subtitle" style="color: null">
                              <p><span style="color: rgb(0, 0, 0)">Sisley是一家法国家族企业，以研发优质美容护肤产品为己任，并秉承可持续发展与环保理念。通过采取务实的行动措施，致力于为产品和公司建立良好声誉，同时与合作伙伴建立长久的合作关系。</span></p>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="ms-row center-xs">
                        <div class="col-xs-12">
                          <div class="c-strat2__image-wrapper">
                            <img
                              class="lazyloaded"
                              alt="La Beauté raisonnée"
                              src="@/assets/imgs/CMS-pages/beautiful-reason/visuel1.jpg"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="ms-row center-xs full-width">
                        <div class="col-xs-10 col-md-8">
                          <div class="c-strat2__title-wrapper-bottom">
                            <div class="c-strat2__big-p" style="color: null">
                              <p><span style="color: rgb(0, 0, 0)">永续美丽的理念激励我们在研发优质产品的同时持续减少生态足迹，因为两者相依相存，不可分割。 </span></p>
                              <p><br /></p>
                            </div>
                            <div class="c-strat2__regular-p" style="color: null">
                              <p><span style="color: rgb(0, 0, 0)">为此，在过去的15年间，Sisley一直谨慎研究并系统性地分析各个环节：从产品设计到销售、从原料采购到生产流程等不同阶段对环境带来的不同影响。</span></p>
                              <p><br /></p>
                              <p><span style="color: rgb(0, 0, 0)">更特意设立了一个专属团队——专注于这项任务，他们的认真与努力为我们带来了极高的价值。必要时，我们还会寻求外部专业合作，为检测公司行动及措施的有效性制定新的指标，希望能不断进步，获得更好的成果。我们的目标是精进不休、永续前进。</span></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-strat3">
        <div style="background-color: #f6f4f1">
          <div class="layout c-strat3">
            <div class="ms-row center-xs">
              <div class="col-xs-12 col-sm-11 col-md-8">
                <div class="c-strat3__title-wrapper">
                  <div class="c-strat3__title" style="color: null">我们的行动</div>
                  <div class="c-strat3__subtitle" style="color: null">
                    <p><strong style="color: rgb(0, 0, 0)">我们对环境的影响</strong></p>
                    <p><span style="color: rgb(0, 0, 0)">Sisley超过90%的产品在法国生产，余下的在欧洲多个国家生产。</span></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="ms-row center-xs">
              <div class="col-xs-12 col-sm-11 col-md-8">
                <div class="experience-component experience-assets-imagetextstrat3">
                  <div class="c-img-start3 layout c-pd-video c-img-start3--extended">
                    <img
                      class="lazyloaded"
                      alt="90% des produits Sisley sont fabriqués en France"
                      src="@/assets/imgs/CMS-pages/beautiful-reason/visuel2.jpg"
                    />
                    <div class="c-img-start3--text-wrapper">
                      <div class="c-img-start3__img-subtitle" style="color: null">
                        <p><span style="color: rgb(0, 0, 0)">我们清楚地意识到自身在不同地区所扮演的角色，并致力于降低对环境的影响。</span></p>
                      </div>
                    </div>
                    <div class="ms-row center-xs">
                      <div class="col-xs-12 col-sm-10 col-md-9"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-1column">
        <div style="">
          <div class="experience-region experience-column1">
            <div class="experience-component experience-assets-strat4">
              <div class="c-strat4 layout layout--full-width" style="">
                <div class="c-strat4--template-wrapper">
                  <div class="layout">
                    <div class="ms-row template_b">
                      <div class="c-strat4__content-wrapper col-xs-10 col-sm-9 col-md-8">
                        <h2 class="c-strat4__title md-text--center" style="color: null">可持续发展建筑</h2>
                        <div class="c-strat4__subtitle md-text--center" style="color: null">
                          <p><span style="color: rgb(0, 0, 0)">Sisley所有生产场所均获HQE认证</span></p>
                        </div>
                        <div class="c-strat4__image-wrapper img-teamplate-b">
                          <img
                            class="lazyloaded c-strat4__image"
                            src="@/assets/imgs/CMS-pages/beautiful-reason/visuel3.jpg"
                            alt="Les sites Sisley bénéficient de la certification HQE."
                          />
                        </div>
                        <div class="c-strat4__content">
                          <div style="color: null">
                            <p><span style="color: rgb(0, 0, 0)">Sisley 重金投资于旗下所有生产场所，特别是位于巴黎和Saint-Ouen I'Aumône的基地，以获取High Quality Environment（HQE）标准认证。</span></p>
                            <p><br /></p>
                            <p><span style="color: rgb(0, 0, 0)">HQE认证以一套严格的检测方法为基础，主要聚焦于四大标准：工作环境质量、责任管理、经济绩效和环境保护（包括资源和能源的使用以及污染排放限制）。</span></p>
                            <p><br /></p>
                            <p><span style="color: rgb(0, 0, 0)">Saint-Ouen I'Aumône是集研发、行政和物流中心为一体的生产基地，坐落于Val-d'Oise省，通过了ISO 14001（环境责任检测）、4500（工作健康和安全）及22716（化妆品质量和安全）认证。而设于Blois的工厂亦通过了以上全部认证。 </span></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-strat1">
        <div class="c-strat1 js_strat c-background layout layout--full-width c-strat1--image" style="background-color: #788097">
          <div class="c-strat1__background js_strat_background c-background__image-container">
            <img class="show-for-md c-background__image js-image--large" src="@/assets/imgs/CMS-pages/beautiful-reason/background1.jpg" />
            <img class="hide-for-md c-background__image js-image--small" src="@/assets/imgs/CMS-pages/beautiful-reason/background1-mobile.jpg" />
          </div>
          <div class="c-strat1__main-image c-background__content-wrapper js_strat_main_image has-image" style="min-height: 749px">
            <div class="layout">
              <div class="ms-row row-with-template c-background__content">
                <div class="col-xs-12 col-md-6">
                  <div class="c-pagedesigner__title-wrapper">
                    <h2 class="c-pagedesigner__title" style="color: #fff">能源和气候</h2>
                    <div class="c-pagedesigner__subtitle" style="color: #fff">
                      <p>Sisley以成为一家低碳企业为目标，持续多年参与对抗全球变暖环保行动，还致力于减少公司业务运作对环境造成的影响。</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="c-strat1--template-wrapper">
                <div class="ms-row c-strat1--rowA">
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row center-xs">
                          <div class="col-xs-12 c-img-start1__elements">
                            <h2 class="sr-only">Autres informations</h2>
                            <div class="c-img-start1__text-wrapper no-title">
                              <div class="c-img-start1--subtitle text--left null" style="color: #fff">
                                <p>自2011年起，公司投入大量资金用于改善操作流程，使Blois厂房生产每款产品所需的能源消耗量大幅减半。</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row center-xs">
                          <div class="col-xs-12 c-img-start1__elements">
                            <h2 class="sr-only">Autres informations</h2>
                            <div class="c-img-start1__text-wrapper no-title">
                              <div class="c-img-start1--subtitle text--left null" style="color: #fff">
                                <p>我们还通过落实以下多项行动，有效降低了温室气体的排放量：</p>
                                <p>办公空间：于Saint-Ouen I'Aumône安装了太阳能光伏屋顶，每年减少排放44吨二氧化碳，让办公室电力消耗100%自给自足。</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row center-xs">
                          <div class="col-xs-12 c-img-start1__elements">
                            <h2 class="sr-only">Autres informations</h2>
                            <div class="c-img-start1__text-wrapper no-title">
                              <div class="c-img-start1--subtitle text--left null" style="color: #fff">
                                <p>交通设备：仅选择混能汽车或电动汽车，在停车场安装充电站，并设立视频会议系统。</p>
                                <p>植物绿化：在Blois和Saint-Ouen I'Aumône分别栽种了4000棵树木。</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                </div>
                <div class="ms-row c-strat1--rowA--last">
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-strat1">
        <div class="c-strat1 js_strat c-background layout layout--full-width null" style="">
          <div class="c-strat1__main-image c-background__content-wrapper js_strat_main_image no-image">
            <div class="layout">
              <div class="ms-row row-with-template c-background__content">
                <div class="col-xs-12 col-md-6">
                  <div class="c-pagedesigner__title-wrapper">
                    <div class="c-pagedesigner__subtitle" style="color: null">
                      <p>水资源和土壤保护</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="c-strat1--template-wrapper">
                <div class="ms-row c-strat1--rowA">
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row center-xs wrapper-img">
                          <div class="col-xs-12 c-img-start1__elements">
                            <h2 class="sr-only">Autres informations</h2>
                            <div class="c-img-start1__imagevideo-wrapper">
                              <img
                                class="lazyloaded"
                                src="@/assets/imgs/CMS-pages/beautiful-reason/chiffre1.png"
                                alt="-22%"
                              />
                            </div>
                            <div class="c-img-start1__text-wrapper no-title">
                              <div class="c-img-start1--subtitle text--left subtitle-content" style="color: null">
                                <p>自2011年起，我们在法国境内的生产设施安装了死循环电路和雨水回收系统，由此将水消耗量减少了22%。</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row center-xs wrapper-img">
                          <div class="col-xs-12 c-img-start1__elements">
                            <h2 class="sr-only">Autres informations</h2>
                            <div class="c-img-start1__imagevideo-wrapper">
                              <img
                                class="lazyloaded"
                                src="@/assets/imgs/CMS-pages/beautiful-reason/chiffre2.png"
                                alt="+33%"
                              />
                            </div>
                            <div class="c-img-start1__text-wrapper no-title">
                              <div class="c-img-start1--subtitle text--left subtitle-content" style="color: null">
                                <p>法国的员工人数增加了33%。</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row center-xs wrapper-img">
                          <div class="col-xs-12 c-img-start1__elements">
                            <h2 class="sr-only">Autres informations</h2>
                            <div class="c-img-start1__imagevideo-wrapper">
                              <img
                                class="lazyloaded"
                                src="@/assets/imgs/CMS-pages/beautiful-reason/chiffre3.png"
                                alt="100%"
                              />
                            </div>
                            <div class="c-img-start1__text-wrapper no-title">
                              <div class="c-img-start1--subtitle text--left subtitle-content" style="color: null">
                                <p>得益于我们的污水净化厂，Blois厂房排出的废水均经过100%净化处理，清洁彻底。</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                </div>
                <div class="ms-row c-strat1--rowA--last">
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-strat1">
        <div class="c-strat1 js_strat c-background layout layout--full-width null" style="background-color: #a2a085">
          <div class="c-strat1__main-image c-background__content-wrapper js_strat_main_image no-image">
            <div class="layout">
              <div class="ms-row row-with-template c-background__content">
                <div class="col-xs-12 col-md-6">
                  <div class="c-pagedesigner__title-wrapper">
                    <h2 class="c-pagedesigner__title" style="color: #fff">资源再生管理</h2>
                    <div class="c-pagedesigner__subtitle" style="color: #fff">
                      <p>2019年的废弃物回收再生使用率高达80%，相较2011年提高了25%。</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="c-strat1--template-wrapper">
                <div class="ms-row c-strat1--rowA">
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row center-xs">
                          <div class="col-xs-12 c-img-start1__elements">
                            <h2 class="sr-only">Autres informations</h2>
                            <div class="c-img-start1__text-wrapper no-title">
                              <div class="c-img-start1--subtitle text--left null" style="color: #fff">
                                <p>我们一直与服务供应商保持合作，以便用创新的方式开辟新的废物回收渠道。我们使用的各类塑料（PVC、PS、PE等）目前已采用此类回收方式。</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row center-xs">
                          <div class="col-xs-12 c-img-start1__elements">
                            <h2 class="sr-only">Autres informations</h2>
                            <div class="c-img-start1__text-wrapper no-title">
                              <div class="c-img-start1--subtitle text--left null" style="color: #fff">
                                <p>为了减少生产设施和包装车间的废物排放量，我们在生产链源头落实了一套相关措施：重复使用所有中间包装材料（像气泡袋、纸板等）。</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row center-xs">
                          <div class="col-xs-12 c-img-start1__elements">
                            <h2 class="sr-only">Autres informations</h2>
                            <div class="c-img-start1__text-wrapper no-title">
                              <div class="c-img-start1--subtitle text--left null" style="color: #fff">
                                <p>此外，我们还调整了配送方式，以优化运输箱的尺寸和填装量。</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                </div>
                <div class="ms-row c-strat1--rowA--last">
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                  <div class="col-xs-12 col-sm-6 col-md-3 strat-col c-strat1--col"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-1column">
        <div style="">
          <div class="experience-region experience-column1">
            <div class="experience-component experience-assets-strat4">
              <div class="c-strat4 layout layout--full-width" style="">
                <div class="c-strat4--template-wrapper">
                  <div class="layout">
                    <div class="ms-row template_a">
                      <div class="col-sm-5 hide-for-xs-only hide-for-sm-only c-strat4__image-container">
                        <div class="c-strat4__image-wrapper c-strat4__wrapper_a">
                          <div class="">
                            <img
                              class="lazyloaded c-strat4__image"
                              src="@/assets/imgs/CMS-pages/beautiful-reason/visuel4.jpg"
                              alt="Sisley améliore son organisation logistique via l’utilisation d’un format de palette spécifique."
                            />
                          </div>
                        </div>
                      </div>
                      <div class="c-strat4__content-wrapper text--no-margin col-xs-10 col-sm-9 col-md-offset-1 col-md-5">
                        <h2 class="c-strat4__title" style="color: null">运输网络</h2>
                        <div class="c-strat4__subtitle" style="color: null">
                          <p><span style="color: rgb(0, 0, 0)">Sisley使用特定规格的栈板来提升物流相关的节能效果。</span></p>
                        </div>
                        <div class="c-strat4__image-wrapper img-teamplate-b">
                          <img
                            class="lazyloaded c-strat4__image"
                            src="@/assets/imgs/CMS-pages/beautiful-reason/visuel4.jpg"
                            alt="Sisley améliore son organisation logistique via l’utilisation d’un format de palette spécifique."
                          />
                        </div>
                        <div class="c-strat4__content">
                          <div style="color: null">
                            <p>我们设计了特定标准尺寸的运输栈板来提升物流节能效率，降低海运货柜的数量，每个货柜平均节省了25%的二氧化碳。</p>
                            <p><br /></p>
                            <p>2014年，我们开始将产品的运输方式从空运移转为海运，2019年，70%的产品使用海运运输，平均减少了90%的二氧化碳排放。</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-1column">
        <div style="">
          <div class="experience-region experience-column1"></div>
        </div>
      </div>
      <div class="experience-component experience-layouts-1column">
        <div style="background-color: #f6f4f1">
          <div class="experience-region experience-column1">
            <div class="experience-component experience-assets-strat4">
              <div class="c-strat4 layout layout--full-width" style="">
                <div class="c-strat4--template-wrapper">
                  <div class="layout">
                    <div class="ms-row template_b">
                      <div class="c-strat4__content-wrapper col-xs-10 col-sm-9 col-md-8">
                        <h2 class="c-strat4__title md-text--center" style="color: null">产品包装</h2>
                        <div class="c-strat4__subtitle md-text--center" style="color: null">
                          <p>Sisley优先为产品使用可回收包装，并通过遵守以下环保设计标准来不断优化包装设计：</p>
                        </div>
                        <div class="c-strat4__image-wrapper img-teamplate-b">
                          <img
                            class="lazyloaded c-strat4__image"
                            src="@/assets/imgs/CMS-pages/beautiful-reason/visuel5.jpg"
                            alt="Les packagings Sisley respectent des critères d'eco-design."
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-1column">
        <div style="background-color: #f6f4f1">
          <div class="experience-region experience-column1">
            <div class="experience-component experience-assets-strat4">
              <div class="c-strat4 layout layout--full-width" style="">
                <div class="c-strat4--template-wrapper">
                  <div class="layout">
                    <div class="ms-row template_b">
                      <div class="c-strat4__content-wrapper col-xs-10 col-sm-9 col-md-8">
                        <div class="c-strat4__subtitle md-text--center" style="color: null">
                          <p>革新包装、在保持包装高质量的同时提高其可回收率、同时寻找对环境影响较小的解决方案。 </p>
                        </div>
                        <div class="c-strat4__image-wrapper img-teamplate-b">
                          <img
                            class="lazyloaded c-strat4__image"
                            src="@/assets/imgs/CMS-pages/beautiful-reason/logo-spice.jpg"
                            alt="projet SPICE "
                          />
                        </div>
                        <div class="c-strat4__content">
                          <div style="color: null">
                            <p><span style="color: rgb(0, 0, 0)">我们亦与美容行业多家企业合作，参与了一项名为「Sustainable Packaging Initiative for CosmEtics」（SPICE）的项目，以减少产品的生态足迹。https://open-spice.com/about-spice/what-is-spice/</span></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-1column">
        <div style="">
          <div class="experience-region experience-column1">
            <div class="experience-component experience-assets-strat4">
              <div class="c-strat4 layout layout--full-width" style=""></div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-1column">
        <div style="">
          <div class="experience-region experience-column1">
            <div class="experience-component experience-assets-strat4">
              <div class="c-strat4 layout layout--full-width" style="">
                <div class="c-strat4--template-wrapper">
                  <div class="layout">
                    <div class="ms-row template_a">
                      <div class="col-sm-5 hide-for-xs-only hide-for-sm-only c-strat4__image-container">
                        <div class="c-strat4__image-wrapper c-strat4__wrapper_a">
                          <div class="">
                            <img
                              class="lazyloaded c-strat4__image"
                              src="@/assets/imgs/CMS-pages/beautiful-reason/visuel6.jpg"
                              alt="Sisley souhaite s'inscrire dans une démarche commerciale plus responsable."
                            />
                          </div>
                        </div>
                      </div>
                      <div class="c-strat4__content-wrapper text--no-margin col-xs-10 col-sm-9 col-md-offset-1 col-md-5">
                        <h2 class="c-strat4__title" style="color: null">采购</h2>
                        <div class="c-strat4__subtitle" style="color: null">
                          <p>Sisley严格执行负责任的采购政策。</p>
                        </div>
                        <div class="c-strat4__image-wrapper img-teamplate-b">
                          <img
                            class="lazyloaded c-strat4__image"
                            src="@/assets/imgs/CMS-pages/beautiful-reason/visuel6.jpg"
                            alt="Sisley souhaite s'inscrire dans une démarche commerciale plus responsable."
                          />
                        </div>
                        <div class="c-strat4__content">
                          <div style="color: null">
                            <p>为此，我们与多个合作伙伴缔结了长期稳定的合作关系，以达到理想的经济平衡点。</p>
                            <p><br /></p>
                            <p><span style="color: rgb(0, 0, 0)">我们期望能在保护环境的同时，使每个参与者都能获得成功。我们的供货商是我们节能行动项目的核心，我们与他们保持合作，不断进步，获得双赢的成果。</span></p>
                            <p><br /></p>
                            <p><span style="color: rgb(0, 0, 0)">我们深知自己的影响力，这也不断激励我们采取更负责任的供应方式，如发展当地经济结构，通过减少二氧化碳排放（运输、环保设计......）来保护环境和生态的多样性。</span></p>
                            <p><br /></p>
                            <p><span style="color: rgb(0, 0, 0)">在发展的过程中，Sisley严选合作伙伴，只与可靠、有责任感，且符合我们企业责任预期的公司合作。每年，我们都会对其社会、环保和道德标准展开评估（透过Ecovadis工具及内部和外部审查）。</span></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-1column">
        <div style="">
          <div class="experience-region experience-column1">
            <div class="experience-component experience-assets-strat4">
              <div class="c-strat4 layout layout--full-width" style="">
                <div class="c-strat4--template-wrapper">
                  <div class="layout">
                    <div class="ms-row template_a">
                      <div class="col-sm-5 hide-for-xs-only hide-for-sm-only c-strat4__image-container">
                        <div class="c-strat4__image-wrapper c-strat4__wrapper_a">
                          <div class="">
                            <div class="c-strat4__video-holder flex-fill c-vimeo-autoplay--with-backup">
                              <div class="c-vimeo-autoplay" style="padding-bottom: 125.51%">
                                <!-- <div
                                  class="c-vimeo-autoplay__iframe c-ratio-container c-ratio-container--secondary without-after-element"
                                  data-vimeo-id="451148801"
                                  data-autoplay="true"
                                  data-width="490"
                                  data-height="615"
                                  id="templateA451148801"
                                  style="padding-bottom: 125.51%"
                                ></div>
                                <img class="c-vimeo-autoplay__image lazyloaded" src="@/assets/imgs/CMS-pages/beautiful-reason/945819583_640.jpg" /> -->
                                <img class="c-vimeo-autoplay__image lazyloaded" src="@/assets/imgs/CMS-pages/beautiful-reason/2037271848.gif" />
                                <!-- <VideoStatic :vSrc="videoSrc.V2037271848"  :iSrc_m="videoSrc.I945819583_640" :isAuto="true" :isLoop="true" :showControls="false" /> -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="c-strat4__content-wrapper text--no-margin col-xs-10 col-sm-9 col-md-offset-1 col-md-5">
                        <h2 class="c-strat4__title" style="color: null">高质量的工作环境</h2>
                        <div class="c-strat4__subtitle" style="color: null">
                          <p><span style="color: rgb(0, 0, 0)">Sisley的工作环境设计旨在促进员工的福祉。</span></p>
                        </div>
                        <div class="c-strat4__image-wrapper img-teamplate-b">
                          <div class="c-strat4__video-holder flex-fill c-vimeo-autoplay--with-backup">
                            <div class="c-vimeo-autoplay" style="padding-bottom: 125.51%">
                              <!-- <div
                                class="c-vimeo-autoplay__iframe c-ratio-container c-ratio-container--secondary without-after-element"
                                data-vimeo-id="451148801"
                                data-autoplay="true"
                                data-width="490"
                                data-height="615"
                                id="451148801templateA"
                                style="padding-bottom: 125.51%"
                              ></div>
                              <img class="c-vimeo-autoplay__image lazyloaded" src="@/assets/imgs/CMS-pages/beautiful-reason/945819583_640.jpg" /> -->
                              <img class="c-vimeo-autoplay__image lazyloaded" src="@/assets/imgs/CMS-pages/beautiful-reason/2037271848.gif" alt="">
                              <!-- <VideoStatic :vSrc="videoSrc.V2037271848"  :iSrc_m="videoSrc.I945819583_640" :isAuto="true" :isLoop="true" :showControls="false" /> -->
                            </div>
                          </div>
                        </div>
                        <div class="c-strat4__content">
                          <div style="color: null">
                            <p><span style="color: rgb(0, 0, 0)">我们每个生产或工作据点均经过精心构思，其空间和美学设计可为员工们提供明亮而方便、促进沟通的环境。</span></p>
                            <p><span style="color: rgb(0, 0, 0)"></span><br/></p>
                            <p><span style="color: rgb(0, 0, 0)">工作间的设计是我们与团队的共同构思，务求让办公桌和工作区域在隔音及人体工学方面能够满足员工需求。</span></p>
                            <p><span style="color: rgb(0, 0, 0)"> </span><br/></p>
                            <p><span style="color: rgb(0, 0, 0)">我们还提供了多项能够帮助改善员工日常生活的服务:在Saint-Ouen I’Aumône设立了一个开阔舒适的空间用以提供各类体育课程；在法国的三个工作地点提供礼宾服务；每周提供免费水果和干果；在Trois Cinq Friedland提供艺术和文化项目:  (https://www.sisley-paris.com/fr-FR/trois-cinq-friedland/)。</span></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-1column">
        <div style="">
          <div class="experience-region experience-column1">
            <div class="experience-component experience-assets-strat4">
              <div class="c-strat4 layout layout--full-width" style="">
                <div class="c-strat4--template-wrapper">
                  <div class="layout">
                    <div class="ms-row template_b">
                      <div class="c-strat4__content-wrapper col-xs-10 col-sm-9 col-md-8">
                        <h2 class="c-strat4__title md-text--center" style="color: null">小行为，大成就</h2>
                        <div class="c-strat4__subtitle md-text--center" style="color: null">
                          <p><span style="color: rgb(0, 0, 0)">每一项措施都对环境至关重要。</span></p>
                        </div>
                        <div class="c-strat4__image-wrapper img-teamplate-b">
                          <div class="c-strat4__video-holder flex-fill c-vimeo-autoplay--with-backup">
                            <div class="c-vimeo-autoplay" style="padding-bottom: 83.3962%">
                              <img class="c-vimeo-autoplay__image lazyloaded" src="@/assets/imgs/CMS-pages/beautiful-reason/2037267381.gif" alt="">
                              <!-- <VideoStatic :vSrc="videoSrc.V2037267381"  :iSrc_m="videoSrc.I945819573_640" :isAuto="true" :isLoop="true" :showControls="false" /> -->
                            </div>
                          </div>
                        </div>
                        <div class="c-strat4__content">
                          <div style="color: null">
                            <p><span style="color: rgb(0, 0, 0)">环保无小事，每一个微小的举动都至关重要。为此，我们安装了能够减少日常资源消耗的设施，如办公室内的移动感应灯、工作间的LED灯，用以减少废纸的共享复印机，以及资源回收措施。</span></p>
                            <p><span style="color: rgb(0, 0, 0)"> </span><br/></p>
                            <p><span style="color: rgb(0, 0, 0)">此外，在Saint-Ouen厂房中，我们在养蜂专家的协助下建置了蜂窝，帮助提升蜜蜂生态，并在绿色空间饲养「生态放牧」的绵羊。</span></p>
                            <p><span style="color: rgb(0, 0, 0)"> </span><br/></p>
                            <p><span style="color: rgb(0, 0, 0)">为了减少塑料废物，Sisley员工在每日工作中只使用马克杯和可重复使用的水杯，或使用饮水器饮水，以避免使用一次性塑料制品。不仅如此，公司的餐桌也不再使用塑料餐具。</span></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-2column">
        <div class="c-pagedesigner__module-space c-pagedesigner__module-space-background" style="background-color: #f9f9f9">
          <div class="layout">
            <div class="ms-row center-xs">
              <div class="col-xs-12 col-md-8 col-lg-6">
                <div class="c-pagedesigner__title-wrapper">
                  <h3 class="c-pagedesigner__title heading-h3 text--center c-pagedesigner__text-content">探索更多</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="layout">
            <div class="ms-row center-xs">
              <div class="col-xs-12 col-sm-6">
                <div class="experience-component experience-assets-editorialpush">
                  <div class="c-editorial-push c-content-carousel__item">
                    <a href="/expertise-sisley" class="c-text-image c-text-image–-secondary">
                      <div class="c-text-image__visual">
                        <img
                          class="lazyloaded"
                          src="@/assets/imgs/CMS-pages/beautiful-reason/rebond-expertise.jpg"
                          alt=""
                        />
                        <div class="c-text-image__visual-title c-text-image__visual-title--thin">
                          <div class="c-text-image__visual-title--uppercase">专业</div>
                          Sisley
                        </div>
                      </div>
                      <div class="c-text-image__content start-xs">
                        <div class="c-text-image__text">
                          <div class="c-text-image__description">Sisley护肤品兼具卓越功效和奢悦感官享受</div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6">
                <div class="experience-component experience-assets-editorialpush">
                  <div class="c-editorial-push c-content-carousel__item">
                    <a href="/entreprise" class="c-text-image c-text-image–-secondary">
                      <div class="c-text-image__visual">
                        <img
                          class="lazyloaded"
                          src="@/assets/imgs/CMS-pages/beautiful-reason/rebond-entreprise.jpg"
                          alt=""
                        />
                        <div class="c-text-image__visual-title c-text-image__visual-title--thin">
                          <div class="c-text-image__visual-title--uppercase">关于公司</div>
                          Sisley
                        </div>
                      </div>
                      <div class="c-text-image__content start-xs">
                        <div class="c-text-image__text">
                          <div class="c-text-image__description">敢于创新的法国家族企业</div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-1column">
        <div style="">
          <div class="experience-region experience-column1">
            <div class="experience-component experience-assets-topCategoryPD">
              <div class="js-pagedesigner-id sr-only" data-pd-id="la-beaute-raisonnee"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>

export default {
  name: "BeautifulReason",
  data() {}
};
</script>

<style lang="css" scoped>
.page{overflow-x: hidden;}
.hidden{display:none}
html{font-family:sans-serif;line-height:1.15;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}
article,aside,footer,header,nav,section{display:block}
h1{font-size:2em;margin:.67em 0}
figcaption,figure,main{display:block}
figure{margin:1em 40px}
hr{box-sizing:content-box;height:0;overflow:visible}
pre{font-family:monospace,monospace;font-size:1em}
a{background-color:transparent;-webkit-text-decoration-skip:objects}
a:active,a:hover{outline-width:0}
abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}
b,strong{font-weight:inherit;font-weight:bolder}
code,kbd,samp{font-family:monospace,monospace;font-size:1em}
dfn{font-style:italic}
mark{background-color:#ff0;color:#000}
sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}
sub{bottom:-.25em}
sup{top:-.5em}
audio,video{display:inline-block}
audio:not([controls]){display:none;height:0}
img{border-style:none}
svg:not(:root){overflow:hidden}
button,input,optgroup,select,textarea{font-family:sans-serif;font-size:100%;line-height:1.15;margin:0}
button,input{overflow:visible}
button,select{text-transform:none}
[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}
[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}
[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}
fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}
legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}
progress{display:inline-block;vertical-align:baseline}
textarea{overflow:auto}
[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}
[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}
[type=search]{-webkit-appearance:textfield;outline-offset:-2px}
[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}
::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}
details,menu{display:block}
summary{display:list-item}
canvas{display:inline-block}
[hidden],template{display:none}
blockquote,dd,div,dl,dt,form,h1,h2,h3,h4,h5,h6,li,ol,p,pre,td,th,ul{margin:0;padding:0}
em,i{font-style:italic}
b,em,i,strong{line-height:inherit}
b,strong{font-weight:700}
small{font-size:80%;line-height:inherit}
address{font-style:normal}
dl,ol,ul{line-height:1.6;margin-bottom:1rem;list-style-position:outside}
li{font-size:inherit}
ul{list-style-type:none}
ol,ul{margin-left:0}
ol ol,ol ul,ul ol,ul ul{margin-left:0;margin-bottom:0}
p{font-size:inherit;line-height:1.6;margin-bottom:1rem;text-rendering:optimizeLegibility}
.heading-h1,.heading-h2,.heading-h3,.heading-h4,.heading-h5,.heading-h6,h1,h2,h3,h4,h5,h6{color:#000;margin-top:0;margin-bottom:.5rem}
.heading-h1,h1{font-family:HelveticaNeueLTW05-35Thin,arial,sans-serif;font-weight:400;font-style:normal;line-height:1.16}
.heading-h2,.heading-h4,.heading-h6,h2,h4,h6{font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-weight:400;font-style:normal}
.heading-h3,h3{text-transform:uppercase;letter-spacing:.0625rem;display:block}
.heading-h3,.heading-h5,h3,h5{font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;font-weight:400;font-style:normal;line-height:1.66}
.heading-h5,h5{letter-spacing:normal}
.heading-h2,h2{line-height:1.32}
.heading-h4,.heading-h6,h4,h6{line-height:1.5}
.heading-h1,.heading-h2,h1,h2{font-size:1.5625rem}
.heading-h3,h3{font-size:.75rem}
.heading-h4,h4{font-size:1rem}
.heading-h5,h5{font-size:.75rem}
.heading-h6,h6{font-size:.875rem}
@media screen and (min-width:48em){.heading-h1,h1{font-size:2.1875rem}.heading-h2,h2{font-size:1.5625rem}.heading-h3,h3{font-size:.75rem}.heading-h4,h4{font-size:1rem}.heading-h5,h5{font-size:.75rem}.heading-h6,h6{font-size:.875rem}}
@media screen and (min-width:64em){.heading-h1,h1{font-size:3.125rem}.heading-h2,h2{font-size:1.5625rem}.heading-h3,h3{font-size:.75rem}.heading-h4,h4{font-size:1rem}.heading-h5,h5{font-size:.75rem}.heading-h6,h6{font-size:.875rem}}
.link,a{color:#000;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;font-size:.75rem;text-decoration:underline;line-height:inherit;cursor:pointer}
.link:focus,a:focus{text-decoration:none}
@media screen and (min-width:75em){.link:hover,a:hover{text-decoration:none}}
.link img,a img{border:0}
html{font-size:100%;box-sizing:border-box}
@media screen and (min-width:64em){html{overflow-x:hidden}}
*,:after,:before{box-sizing:inherit}
body{padding:0;margin:0;font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-weight:400;line-height:1.6;font-size:.8125rem;color:#575757;background:#fff;overflow-x:hidden;opacity:1;transition:opacity 1s;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}
body.fade-out{opacity:0;transition:none}
body:not(.popin-open):not(.no-scroll):not(.js-no-scroll){-webkit-overflow-scrolling:touch}
body.mouse-clicked a:focus,body.mouse-clicked a:focus-within,body.mouse-clicked area:focus,body.mouse-clicked area:focus-within,body.mouse-clicked button:focus,body.mouse-clicked button:focus-within,body.mouse-clicked div:focus,body.mouse-clicked div:focus-within,body.mouse-clicked iframe:focus,body.mouse-clicked iframe:focus-within,body.mouse-clicked input:focus,body.mouse-clicked input:focus-within,body.mouse-clicked select:focus,body.mouse-clicked select:focus-within,body.mouse-clicked textarea:focus,body.mouse-clicked textarea:focus-within{outline:none!important;outline-width:0!important;box-shadow:none!important;-moz-box-shadow:none!important;-webkit-box-shadow:none!important}
body.mouse-clicked a:after,body.mouse-clicked a:before,body.mouse-clicked area:after,body.mouse-clicked area:before,body.mouse-clicked button:after,body.mouse-clicked button:before,body.mouse-clicked div:after,body.mouse-clicked div:before,body.mouse-clicked iframe:after,body.mouse-clicked iframe:before,body.mouse-clicked input:after,body.mouse-clicked input:before,body.mouse-clicked select:after,body.mouse-clicked select:before,body.mouse-clicked textarea:after,body.mouse-clicked textarea:before{outline-color:transparent!important}
.text--no-margin{margin:0}
fieldset{border:0;padding:0;margin:0}
textarea{height:auto;min-height:50px}
select{width:100%;z-index:1!important}
button{-webkit-appearance:none;-moz-appearance:none;background:transparent;padding:0;border:0;border-radius:0;line-height:1}
input::-webkit-credentials-auto-fill-button{visibility:hidden;display:none;pointer-events:none;position:absolute;right:0}
form{position:relative}
.disabled{pointer-events:none}
img{-ms-interpolation-mode:bicubic;display:inline-block;vertical-align:middle}
img,object,video{max-width:100%;height:auto}
video::-webkit-media-controls-start-playback-button{display:none}
.lazyload{opacity:0}
.lazyloading{opacity:.25;transition:opacity .2s}
.lazyloaded{opacity:1;transition:opacity .2s}
.container,.container-fluid{margin-right:auto;margin-left:auto}
.container{width:100%;max-width:75rem}
.container-fluid{padding-right:2rem;padding-left:2rem}
.col.reverse{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}
.flex-column{flex-direction:column}
.col-xs,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12,.col-xs-offset-0,.col-xs-offset-1,.col-xs-offset-2,.col-xs-offset-3,.col-xs-offset-4,.col-xs-offset-5,.col-xs-offset-6,.col-xs-offset-7,.col-xs-offset-8,.col-xs-offset-9,.col-xs-offset-10,.col-xs-offset-11,.col-xs-offset-12{box-sizing:border-box;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;padding-right:.625rem;padding-left:.625rem}
.col-xs{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}
.col-xs-1{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}
.col-xs-2{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}
.col-xs-3{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}
.col-xs-4{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}
.col-xs-5{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}
.col-xs-6{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}
.col-xs-7{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}
.col-xs-8{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}
.col-xs-9{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}
.col-xs-10{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}
.col-xs-11{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}
.col-xs-12{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}
.col-xs-offset-0{margin-left:0}
.col-xs-offset-1{margin-left:8.33333333%}
.col-xs-offset-2{margin-left:16.66666667%}
.col-xs-offset-3{margin-left:25%}
.col-xs-offset-4{margin-left:33.33333333%}
.col-xs-offset-5{margin-left:41.66666667%}
.col-xs-offset-6{margin-left:50%}
.col-xs-offset-7{margin-left:58.33333333%}
.col-xs-offset-8{margin-left:66.66666667%}
.col-xs-offset-9{margin-left:75%}
.col-xs-offset-10{margin-left:83.33333333%}
.col-xs-offset-11{margin-left:91.66666667%}
.display-flex-xs{display:-webkit-box;display:-ms-flexbox;display:flex}
.ms-row.reversed{-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}
.ms-row,.ms-row.reversed{-webkit-box-orient:horizontal}
.ms-row{box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-.625rem;margin-left:-.625rem}
.flex-nowrap-md{flex-wrap:nowrap}
.flex-wrap{flex-wrap:wrap}
.ms-row--second{margin-left:-.5rem;margin-right:-.5rem}
.ms-row--second .col-xs,.ms-row--second .col-xs-1,.ms-row--second .col-xs-2,.ms-row--second .col-xs-3,.ms-row--second .col-xs-4,.ms-row--second .col-xs-5,.ms-row--second .col-xs-6,.ms-row--second .col-xs-7,.ms-row--second .col-xs-8,.ms-row--second .col-xs-9,.ms-row--second .col-xs-10,.ms-row--second .col-xs-11,.ms-row--second .col-xs-12,.ms-row--second .col-xs-offset-0,.ms-row--second .col-xs-offset-1,.ms-row--second .col-xs-offset-2,.ms-row--second .col-xs-offset-3,.ms-row--second .col-xs-offset-4,.ms-row--second .col-xs-offset-5,.ms-row--second .col-xs-offset-6,.ms-row--second .col-xs-offset-7,.ms-row--second .col-xs-offset-8,.ms-row--second .col-xs-offset-9,.ms-row--second .col-xs-offset-10,.ms-row--second .col-xs-offset-11,.ms-row--second .col-xs-offset-12{padding-right:.5rem;padding-left:.5rem}
.ms-row--third{margin-left:-.5rem;margin-right:-.5rem}
@media screen and (min-width:48em) and (max-width:63.9375em){.ms-row--third{margin-left:-.75rem;margin-right:-.75rem}}
.ms-row--third .col-xs,.ms-row--third .col-xs-1,.ms-row--third .col-xs-2,.ms-row--third .col-xs-3,.ms-row--third .col-xs-4,.ms-row--third .col-xs-5,.ms-row--third .col-xs-6,.ms-row--third .col-xs-7,.ms-row--third .col-xs-8,.ms-row--third .col-xs-9,.ms-row--third .col-xs-10,.ms-row--third .col-xs-11,.ms-row--third .col-xs-12,.ms-row--third .col-xs-offset-0,.ms-row--third .col-xs-offset-1,.ms-row--third .col-xs-offset-2,.ms-row--third .col-xs-offset-3,.ms-row--third .col-xs-offset-4,.ms-row--third .col-xs-offset-5,.ms-row--third .col-xs-offset-6,.ms-row--third .col-xs-offset-7,.ms-row--third .col-xs-offset-8,.ms-row--third .col-xs-offset-9,.ms-row--third .col-xs-offset-10,.ms-row--third .col-xs-offset-11,.ms-row--third .col-xs-offset-12{padding-right:.5rem;padding-left:.5rem}
@media screen and (min-width:48em) and (max-width:63.9375em){.ms-row--third .col-xs,.ms-row--third .col-xs-1,.ms-row--third .col-xs-2,.ms-row--third .col-xs-3,.ms-row--third .col-xs-4,.ms-row--third .col-xs-5,.ms-row--third .col-xs-6,.ms-row--third .col-xs-7,.ms-row--third .col-xs-8,.ms-row--third .col-xs-9,.ms-row--third .col-xs-10,.ms-row--third .col-xs-11,.ms-row--third .col-xs-12,.ms-row--third .col-xs-offset-0,.ms-row--third .col-xs-offset-1,.ms-row--third .col-xs-offset-2,.ms-row--third .col-xs-offset-3,.ms-row--third .col-xs-offset-4,.ms-row--third .col-xs-offset-5,.ms-row--third .col-xs-offset-6,.ms-row--third .col-xs-offset-7,.ms-row--third .col-xs-offset-8,.ms-row--third .col-xs-offset-9,.ms-row--third .col-xs-offset-10,.ms-row--third .col-xs-offset-11,.ms-row--third .col-xs-offset-12{padding-right:.75rem;padding-left:.75rem}}
@media screen and (min-width:48em) and (max-width:63.9375em){.ms-row--third .col-padding-sm--left{padding-left:calc(8.33333% - .75rem)}.ms-row--third .col-padding-sm--right{padding-right:calc(8.33333% - .75rem)}}
.ms-row--third .col-padding-xs{padding:0 calc(8.33333% - .5rem)}
@media screen and (min-width:48em) and (max-width:63.9375em){.ms-row--third .col-padding-xs{padding-right:.75rem;padding-left:.75rem}}
@media screen and (min-width:64em){.ms-row--third .col-padding-xs{padding-right:.5rem;padding-left:.5rem}}
.ms-row--third .col-xs--expanded-right{padding:0 calc(8.33333% - .5rem) 0 .5rem}
@media screen and (min-width:48em) and (max-width:63.9375em){.ms-row--third .col-xs--expanded-right{padding-right:.75rem;padding-left:.75rem}}
@media screen and (min-width:64em){.ms-row--third .col-xs--expanded-right{padding-right:.5rem;padding-left:.5rem}}
.ms-row--third .col-xs--expanded-left{padding:0 .5rem 0 calc(8.33333% - .5rem)}
@media screen and (min-width:48em) and (max-width:63.9375em){.ms-row--third .col-xs--expanded-left{padding-right:.75rem;padding-left:.75rem}}
@media screen and (min-width:64em){.ms-row--third .col-xs--expanded-left{padding-right:.5rem;padding-left:.5rem}}
.ms-row.collapsed{margin-left:0;margin-right:0}
.ms-row.collapsed .col-xs,.ms-row.collapsed .col-xs-1,.ms-row.collapsed .col-xs-2,.ms-row.collapsed .col-xs-3,.ms-row.collapsed .col-xs-4,.ms-row.collapsed .col-xs-5,.ms-row.collapsed .col-xs-6,.ms-row.collapsed .col-xs-7,.ms-row.collapsed .col-xs-8,.ms-row.collapsed .col-xs-9,.ms-row.collapsed .col-xs-10,.ms-row.collapsed .col-xs-11,.ms-row.collapsed .col-xs-12,.ms-row.collapsed .col-xs-offset-0,.ms-row.collapsed .col-xs-offset-1,.ms-row.collapsed .col-xs-offset-2,.ms-row.collapsed .col-xs-offset-3,.ms-row.collapsed .col-xs-offset-4,.ms-row.collapsed .col-xs-offset-5,.ms-row.collapsed .col-xs-offset-6,.ms-row.collapsed .col-xs-offset-7,.ms-row.collapsed .col-xs-offset-8,.ms-row.collapsed .col-xs-offset-9,.ms-row.collapsed .col-xs-offset-10,.ms-row.collapsed .col-xs-offset-11,.ms-row.collapsed .col-xs-offset-12{padding-right:0;padding-left:0}
.ms-row.expanded{margin-right:-.625rem;margin-left:-.625rem}
.flex-fill{flex-grow:1}
.start-xs{text-align:left;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:start}
.center-xs{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}
.end-xs{text-align:right;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;text-align:end}
.top-xs{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}
.middle-xs{-webkit-box-align:center;-ms-flex-align:center;align-items:center}
.bottom-xs{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}
.self-bottom-xs{-webkit-align-self:end;-ms-grid-column-align:end;align-self:flex-end}
.around-xs{-ms-flex-pack:distribute;justify-content:space-around}
.between-xs{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}
.first-xs{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}
.last-xs{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}
@media screen and (min-width:48em){
  .col-sm,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-offset-0,.col-sm-offset-1,.col-sm-offset-2,.col-sm-offset-3,.col-sm-offset-4,.col-sm-offset-5,.col-sm-offset-6,.col-sm-offset-7,.col-sm-offset-8,.col-sm-offset-9,.col-sm-offset-10,.col-sm-offset-11,.col-sm-offset-12{box-sizing:border-box;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;padding-right:.625rem;padding-left:.625rem}
  .col-sm{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}
  .col-sm-1{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}
  .col-sm-2{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}
  .col-sm-3{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}
  .col-sm-4{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}
  .col-sm-5{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}
  .col-sm-6{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}
  .col-sm-7{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}
  .col-sm-8{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}
  .col-sm-9{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}
  .col-sm-10{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}
  .col-sm-11{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}
  .col-sm-12{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}
  .col-sm-offset-0{margin-left:0}
  .col-sm-offset-1{margin-left:8.33333333%}
  .col-sm-offset-2{margin-left:16.66666667%}
  .col-sm-offset-3{margin-left:25%}
  .col-sm-offset-4{margin-left:33.33333333%}
  .col-sm-offset-5{margin-left:41.66666667%}
  .col-sm-offset-6{margin-left:50%}
  .col-sm-offset-7{margin-left:58.33333333%}
  .col-sm-offset-8{margin-left:66.66666667%}
  .col-sm-offset-9{margin-left:75%}
  .col-sm-offset-10{margin-left:83.33333333%}
  .col-sm-offset-11{margin-left:91.66666667%}
  .display-flex-sm{display:-webkit-box;display:-ms-flexbox;display:flex}
  .start-sm{text-align:left;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:start}
  .center-sm{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}
  .end-sm{text-align:right;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;text-align:end}
  .top-sm{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}
  .middle-sm{-webkit-box-align:center;-ms-flex-align:center;align-items:center}
  .bottom-sm{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}
  .self-bottom-sm{-webkit-align-self:end;-ms-grid-column-align:end;align-self:flex-end}
  .around-sm{-ms-flex-pack:distribute;justify-content:space-around}
  .between-sm{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}
  .first-sm{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}
  .last-sm{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}
}
@media screen and (min-width:64em){
  .col-md,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-md-offset-0,.col-md-offset-1,.col-md-offset-2,.col-md-offset-3,.col-md-offset-4,.col-md-offset-5,.col-md-offset-6,.col-md-offset-7,.col-md-offset-8,.col-md-offset-9,.col-md-offset-10,.col-md-offset-11,.col-md-offset-12{box-sizing:border-box;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;padding-right:.625rem;padding-left:.625rem}
  .col-md{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}
  .col-md-1{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}
  .col-md-2{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}
  .col-md-3{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}
  .col-md-4{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}
  .col-md-5{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}
  .col-md-6{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}
  .col-md-7{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}
  .col-md-8{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}
  .col-md-9{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}
  .col-md-10{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}
  .col-md-11{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}
  .col-md-12{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}
  .col-md-offset-0{margin-left:0}
  .col-md-offset-1{margin-left:8.33333333%}
  .col-md-offset-2{margin-left:16.66666667%}
  .col-md-offset-3{margin-left:25%}
  .col-md-offset-4{margin-left:33.33333333%}
  .col-md-offset-5{margin-left:41.66666667%}
  .col-md-offset-6{margin-left:50%}
  .col-md-offset-7{margin-left:58.33333333%}
  .col-md-offset-8{margin-left:66.66666667%}
  .col-md-offset-9{margin-left:75%}
  .col-md-offset-10{margin-left:83.33333333%}
  .col-md-offset-11{margin-left:91.66666667%}
  .display-flex-md{display:-webkit-box;display:-ms-flexbox;display:flex}
  .start-md{text-align:left;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:start}
  .center-md{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}
  .end-md{text-align:right;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;text-align:end}
  .top-md{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}
  .middle-md{-webkit-box-align:center;-ms-flex-align:center;align-items:center}
  .bottom-md{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}
  .self-bottom-md{-webkit-align-self:end;-ms-grid-column-align:end;align-self:flex-end}
  .around-md{-ms-flex-pack:distribute;justify-content:space-around}
  .between-md{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}
  .first-md{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}
  .last-md{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}
}
@media screen and (min-width:75em){
  .col-lg,.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-offset-0,.col-lg-offset-1,.col-lg-offset-2,.col-lg-offset-3,.col-lg-offset-4,.col-lg-offset-5,.col-lg-offset-6,.col-lg-offset-7,.col-lg-offset-8,.col-lg-offset-9,.col-lg-offset-10,.col-lg-offset-11,.col-lg-offset-12{box-sizing:border-box;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;padding-right:.625rem;padding-left:.625rem}
  .col-lg{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}
  .col-lg-1{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}
  .col-lg-2{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}
  .col-lg-3{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}
  .col-lg-4{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}
  .col-lg-5{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}
  .col-lg-6{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}
  .col-lg-7{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}
  .col-lg-8{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}
  .col-lg-9{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}
  .col-lg-10{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}
  .col-lg-11{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}
  .col-lg-12{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}
  .col-lg-offset-0{margin-left:0}
  .col-lg-offset-1{margin-left:8.33333333%}
  .col-lg-offset-2{margin-left:16.66666667%}
  .col-lg-offset-3{margin-left:25%}
  .col-lg-offset-4{margin-left:33.33333333%}
  .col-lg-offset-5{margin-left:41.66666667%}
  .col-lg-offset-6{margin-left:50%}
  .col-lg-offset-7{margin-left:58.33333333%}
  .col-lg-offset-8{margin-left:66.66666667%}
  .col-lg-offset-9{margin-left:75%}
  .col-lg-offset-10{margin-left:83.33333333%}
  .col-lg-offset-11{margin-left:91.66666667%}
  .display-flex-lg{display:-webkit-box;display:-ms-flexbox;display:flex}
  .start-lg{text-align:left;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:start}
  .center-lg{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}
  .end-lg{text-align:right;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;text-align:end}
  .top-lg{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}
  .middle-lg{-webkit-box-align:center;-ms-flex-align:center;align-items:center}
  .bottom-lg{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}
  .self-bottom-lg{-webkit-align-self:end;-ms-grid-column-align:end;align-self:flex-end}
  .around-lg{-ms-flex-pack:distribute;justify-content:space-around}
  .between-lg{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}
  .first-lg{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}
  .last-lg{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}
}
.hide{display:none!important}
.show{display:block!important}
@media screen and (max-width:47.9375em){.hide-for-xs-only{display:none!important}}
@media screen and (min-width:48em){.hide-for-sm{display:none!important}}
@media screen and (min-width:48em) and (max-width:63.9375em){.hide-for-sm-only{display:none!important}}
@media screen and (min-width:64em){.hide-for-md{display:none!important}}
@media screen and (max-width:63.9375em){.show-for-md{display:none!important}}
.text--left{text-align:left}
.text--center{text-align:center}
@media screen and (min-width:64em){.md-text--center{text-align:center}}
.layout{max-width:75rem;margin:0 auto;position:relative}
.layout--full-width{width:100%;max-width:100%}
.c-ratio-container{position:relative}
.c-ratio-container:after{content:"";display:block;height:0;width:100%}
.c-ratio-container>*{display:block}
@media screen and (min-width:64em){.c-ratio-container>*{position:absolute;top:0;left:0;width:100%;height:100%}}
.c-ratio-container--secondary>*{position:absolute;top:0;left:0;width:100%;height:100%}
.c-vimeo-autoplay{background-color:#000;position:relative}
@media screen and (min-width:48em){.c-vimeo-autoplay{background-color:transparent}}
.c-vimeo-autoplay__iframe{display:block;min-height:6.25rem;z-index:1;position:relative}
.c-vimeo-autoplay__iframe iframe{max-width:100%;display:block}
.c-vimeo-autoplay__image{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:100%}
input::-ms-clear,input::-ms-reveal{display:none}
.sr-only{border:0!important;clip:rect(1px,1px,1px,1px)!important;-webkit-clip-path:inset(50%)!important;clip-path:inset(50%)!important;height:1px!important;overflow:hidden!important;padding:0!important;position:absolute!important;width:1px!important;white-space:nowrap!important}
.c-pagedesigner{color:#000}
.c-pagedesigner .c-vimeo-autoplay{overflow:hidden;background-color:transparent}
.c-pagedesigner .c-vimeo-autoplay__image{height:100%;width:auto}
.c-pagedesigner .without-after-element:after{display:none}
.c-pagedesigner .c-background__image-container{position:absolute;top:0}
@media screen and (min-width:64em){.c-pagedesigner .c-background__image-container{position:relative}}
@media screen and (min-width:64em){.c-pagedesigner .c-background__image{position:absolute;left:50%;transform:translateX(-50%);max-width:none}}
.c-pagedesigner .c-strat__container>.experience-component:not(:last-child) .c-strat2 .has-image,.c-pagedesigner .c-strat__container>.experience-component:not(:last-child) .c-strat3 .has-image,.c-pagedesigner .c-strat__container>.experience-component:not(:last-child) .c-strat4 .has-image,.c-pagedesigner .c-strat__container>.experience-component:not(:last-child) .c-strat5 .has-image{margin-bottom:4.6875rem}
.c-pagedesigner__text-content{margin-bottom:2.1875rem}
.c-pagedesigner__title-wrapper{margin-top:1.25rem}
@media screen and (min-width:64em){.c-pagedesigner__title-wrapper{margin-top:3.125rem}}
@media screen and (min-width:75em){.c-pagedesigner__title-wrapper{margin-top:3.125rem}}
.c-pagedesigner__title{padding:0 1.0625rem}
@media screen and (min-width:48em){.c-pagedesigner__title{padding:0 3.875rem}}
@media screen and (min-width:64em){.c-pagedesigner__title{padding:0 1.875rem}}
@media screen and (min-width:75em){.c-pagedesigner__title{padding:0}}
.c-pagedesigner__title p{margin:0}
.c-pagedesigner__subtitle{margin-top:.6875rem;padding:0 1.0625rem}
@media screen and (min-width:48em){.c-pagedesigner__subtitle{padding:0 3.875rem}}
@media screen and (min-width:64em){.c-pagedesigner__subtitle{padding:0 1.875rem}}
@media screen and (min-width:75em){.c-pagedesigner__subtitle{padding:0}}
.c-pagedesigner__module-space{padding:2.5rem 1.0625rem 2.8125rem}
@media screen and (min-width:48em){.c-pagedesigner__module-space{padding:3.125rem}}
.c-pagedesigner .experience-layouts-strat3+.experience-layouts-2column .c-pagedesigner__module-space-background,.c-pagedesigner__module-space-background{margin-top:0}
.c-pagedesigner a{text-decoration:underline}
.c-pagedesigner a:hover{text-decoration:none;color:#c4926d!important}
.c-text-image{display:block;text-decoration:none}
.c-text-image–-secondary,.c-text-image–-secondary .c-text-image__visual{position:relative}
@media screen and (min-width:64em){
  .c-text-image–-secondary .c-text-image__visual:after{content:"";position:absolute;width:100%;height:100%;background:transparent;top:0;left:0;-webkit-transition:background .5s ease-in-out;transition:background .5s ease-in-out}
  .c-text-image–-secondary .c-text-image__visual:hover:after{background:rgba(0,0,0,.4)}
}
.c-text-image–-secondary .c-text-image__visual-title{font-size:1.25rem;font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;color:#fff;text-align:center;line-height:1;text-decoration:none;width:100%;position:absolute;top:0;height:100%;display:flex;justify-content:center;align-items:center;flex-direction:column;z-index:1}
.c-text-image–-secondary .c-text-image__visual-title:before{content:"";width:100%;height:100%;top:0;left:0;position:absolute;z-index:1}
.c-text-image–-secondary .c-text-image__visual-title--thin{font-family:HelveticaNeueLTW05-35Thin,arial,sans-serif;line-height:1.25rem}
@media screen and (min-width:48em){.c-text-image–-secondary .c-text-image__visual-title--thin{line-height:2.5rem}}
.c-text-image–-secondary .c-text-image__visual-title--uppercase{font-size:1.875rem;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;letter-spacing:-.05rem;display:block}
.c-text-image–-secondary .c-text-image__visual-title--secondary{font-size:1.875rem;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;top:50%;left:50%;transform:translate(-50%,-50%);height:auto;display:inline-block}
.c-text-image–-secondary .c-text-image__visual-title--top{position:absolute;top:-.5625rem;left:50%;transform:translate(-50%)}
@media screen and (min-width:48em){.c-text-image–-secondary .c-text-image__visual-title{font-size:2.5rem}.c-text-image–-secondary .c-text-image__visual-title--uppercase{font-size:3.75rem;letter-spacing:-.075rem}}
.c-text-image–-secondary .c-text-image__content{display:flex}
.c-text-image–-secondary .c-text-image__content .c-text-image__text{flex-grow:1;width:0;text-align:left}
.c-text-image–-secondary .c-text-image__description{font-size:.875rem;font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;color:#575757;max-width:24.375rem;padding-top:.3125rem}
@media screen and (min-width:64em){.c-text-image–-secondary .c-text-image__description{margin-top:.625rem}}
.c-content-carousel__item{padding:0 .625rem;text-align:center}
@media screen and (min-width:48em){.c-content-carousel__item{padding:0 .75rem}}
@media screen and (min-width:64em){.c-content-carousel__item{padding:0 .5rem}}
.c-editorial-push{display:flex;justify-content:center;margin:0 0 2.1875rem;width:100%}
.c-editorial-push a{text-decoration:none;width:100%}
.c-editorial-push .c-text-image–-secondary .c-text-image__visual-title{font-size:1.25rem;font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;color:#fff;text-align:center;line-height:1;text-decoration:none;display:inline-block;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);height:auto}
@media screen and (min-width:48em){.c-editorial-push .c-text-image–-secondary .c-text-image__visual-title{margin-top:0}}
.c-editorial-push .c-text-image–-secondary .c-text-image__visual-title--thin{font-size:1.25rem;line-height:2.5rem;font-family:HelveticaNeueLTW05-35Thin,arial,sans-serif}
@media screen and (min-width:48em){.c-editorial-push .c-text-image–-secondary .c-text-image__visual-title--thin{font-size:2.5rem}}
.c-editorial-push .c-text-image–-secondary .c-text-image__visual-title--uppercase{font-size:1.875rem}
@media screen and (min-width:48em){.c-editorial-push .c-text-image–-secondary .c-text-image__visual-title--uppercase{font-size:3.75rem}}
.c-editorial-push .c-text-image__visual{width:100%;overflow:hidden}
@media screen and (min-width:64em){.c-editorial-push .c-text-image__visual{height:auto}}
@media screen and (min-width:48em){.c-editorial-push{margin:0 0 5rem}}
@media screen and (min-width:64em){.c-editorial-push{margin:0 0 3.125rem}}
.c-image-text{margin:6.25rem auto 0}
@media screen and (min-width:48em){.c-image-text{margin:9.375rem auto 0}}
.c-image-text h1,.c-image-text h2,.c-image-text h3,.c-image-text h4{font-family:PlayfairDisplay-Bold,arial,sans-serif}
.c-image-text__content{margin-top:0}
.c-image-text .c-ratio-container--secondary{position:relative}
.c-image-text .c-ratio-container--secondary:after{padding-bottom:59%}
@media screen and (min-width:48em){.c-image-text .c-ratio-container--secondary:after{padding-bottom:75%}}
.c-strat1__background{bottom:0;top:unset}
@media screen and (min-width:48em) and (max-width:63.9375em){.c-strat1__background{width:100%}}
.c-strat1--col{padding:0 .5625rem}
.c-strat1--col .c-img-start1{margin-bottom:3.125rem}
@media screen and (min-width:64em){.c-strat1--col .c-img-start1{margin-bottom:0}}
.c-strat1__main-image{padding:0 2.0625rem}
@media screen and (min-width:48em){.c-strat1__main-image{padding:0 1.875rem}}
@media screen and (min-width:64em){.c-strat1__main-image{padding:0 3.8125rem}}
@media screen and (min-width:75em){.c-strat1__main-image{padding:0}}
@media screen and (min-width:48em) and (max-width:63.9375em){.c-strat1 .c-background__image{width:100%;max-width:100%}}
.c-strat1 .c-pagedesigner__title{font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;font-size:.9375rem;line-height:1.25rem;letter-spacing:.125rem;text-transform:uppercase;margin-bottom:1.875rem;padding:0}
@media screen and (min-width:48em){.c-strat1 .c-pagedesigner__title-wrapper{margin-bottom:3.125rem;margin-top:0}}
.c-strat1 .c-pagedesigner__subtitle{padding:0}
.c-strat1 .c-pagedesigner__subtitle p{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:2.0625rem;line-height:2.1875rem;margin-bottom:0}
@media screen and (min-width:48em){.c-strat1 .c-pagedesigner__subtitle p{font-size:2.25rem;line-height:2.4375rem}}
.c-strat1 .c-pagedesigner__subtitle p:last-child{margin-bottom:0}
.c-strat1 .c-pagedesigner__subtitle a{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:2.0625rem;line-height:2.1875rem;color:inherit}
@media screen and (min-width:48em){.c-strat1 .c-pagedesigner__subtitle a{font-size:2.25rem;line-height:2.4375rem}}
.c-strat1 .col-md-3 .c-ratio-container--secondary:after{padding-bottom:75%}
.c-strat1 .col-md-4 .c-ratio-container--secondary:after{padding-bottom:64%}
.c-strat1 .col-md-6 .c-ratio-container--secondary:after{padding-bottom:76%}
.c-strat1--rowA,.c-strat1--rowB,.c-strat1--rowC{margin-top:0}
@media screen and (min-width:64em){.c-strat1--rowA--last .c-img-start1,.c-strat1--rowB--last .c-img-start1,.c-strat1--rowC--last .c-img-start1{margin-top:3.125rem}}
.c-strat1 .row-with-template{margin-bottom:3.125rem}
@media screen and (min-width:48em){.c-strat1 .row-with-template{padding-top:0;margin-bottom:0}}
@media screen and (min-width:48em){.c-strat1 .c-background__content-wrapper{padding:4.6875rem 2.8125rem}}
@media screen and (min-width:75em){.c-strat1 .c-background__content-wrapper{padding:4.6875rem 0}}
.c-strat1.c-strat1--image{padding:4.6875rem 0}
@media screen and (min-width:64em){.c-strat1.c-strat1--image{padding:0}}
@media screen and (min-width:48em){.c-img-start1{padding:0 .125rem}}
@media screen and (min-width:64em){.c-img-start1{padding:0}}
.c-img-start1 .img.c-img-start1--text-wrapper{margin-top:1.25rem}
.c-img-start1__elements{display:flex;flex-direction:column}
.c-img-start1__title-wrapper{display:flex;order:2}
.c-img-start1__imagevideo-wrapper{order:1}
.c-img-start1__text-wrapper{display:flex;order:3}
.c-img-start1--title{font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;line-height:1.5rem;text-transform:none;font-size:.8125rem;margin-bottom:0}
@media screen and (min-width:48em){.c-img-start1--title{font-size:1rem}}
.c-img-start1--subtitle{margin-top:1.25rem}
.c-img-start1--subtitle p{margin-bottom:0}
.c-img-start1--subtitle a,.c-img-start1--subtitle p{font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-size:.8125rem;line-height:1.3125rem}
@media screen and (min-width:48em){.c-img-start1--subtitle a,.c-img-start1--subtitle p{font-size:1rem;line-height:1.5rem}}
.c-img-start1--subtitle a{color:inherit}
.c-img-start1--subtitle p:last-child{margin-bottom:0;margin-top:0}
@media screen and (min-width:48em){.c-img-start1--subtitle p:last-child{margin-bottom:0}}
.c-img-start1 .no-title .c-img-start1--subtitle{margin-top:0}
.c-img-start1 .wrapper-img .c-img-start1--subtitle,.c-img-start1 .wrapper-img .c-img-start1--title{margin-top:1.25rem}
@media screen and (min-width:48em){.c-img-start1 .wrapper-img .no-title .c-img-start1--subtitle{margin-top:1.25rem}}
.c-img-start1 .subtitle-content{margin-top:1.25rem}
.c-strat2__main-image{text-align:center;padding:4.6875rem 0}
@media screen and (min-width:48em){.c-strat2__main-image{padding:4.6875rem 1.875rem}}
@media screen and (min-width:75em){.c-strat2__main-image{padding:4.6875rem 0}}
.c-strat2--image{padding:0}
.c-strat2--image .has-image{margin-bottom:4.6875rem}
.c-strat2__image-wrapper,.c-strat2__title-wrapper-bottom{margin-top:3.125rem}
.c-strat2__title h2{color:inherit;font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:2.5rem;line-height:2.625rem;margin-bottom:0}
@media screen and (min-width:48em){.c-strat2__title h2{font-size:4.7rem;line-height:4.25rem}}
.c-strat2__title h2:last-child{margin-bottom:1.25rem}
.c-strat2__title h2 a{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:inherit;color:inherit}
.c-strat2__subtitle{color:inherit}
.c-strat2__subtitle p{font-size:1rem;line-height:1.5rem;margin-bottom:0}
.c-strat2__subtitle p,.c-strat2__subtitle p a{font-family:HelveticaNeueLTW05-45Light,arial,sans-serif}
.c-strat2__subtitle p a{font-size:inherit;color:inherit}
.c-strat2__big-p{color:inherit;text-align:center}
.c-strat2__big-p p{font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-size:1rem;line-height:1.5rem;margin-bottom:0}
@media screen and (min-width:48em){.c-strat2__big-p p{font-size:1.5625rem;line-height:2rem}}
.c-strat2__big-p p a{font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-size:inherit;color:inherit}
.c-strat2__regular-p{color:inherit;text-align:center;margin-top:1.25rem}
.c-strat2__regular-p p{font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-size:.8125rem;line-height:1.3125rem;margin-bottom:0}
@media screen and (min-width:48em){.c-strat2__regular-p p{font-size:1rem;line-height:1.5rem}}
.c-strat2__regular-p p a{font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-size:inherit;color:inherit}
.c-strat3{padding:4.6875rem 1.125rem 1.5625rem}
@media screen and (min-width:48em){.c-strat3{padding:4.6875rem 2.0625rem 1.5625rem}}
@media screen and (min-width:64em){.c-strat3{padding:4.6875rem 0 1.5625rem}}
.c-strat3__title{font-size:.9375rem;line-height:1.25rem;letter-spacing:.125rem}
.c-strat3__title,.c-strat3__title a{color:inherit;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif}
.c-strat3__title a{font-size:inherit}
.c-strat3__title-wrapper{margin-bottom:3.125rem}
.c-strat3__subtitle{color:inherit;margin-top:1.25rem}
.c-strat3__subtitle p{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:2.0625rem;line-height:2.1875rem;margin-bottom:0}
@media screen and (min-width:48em){.c-strat3__subtitle p{font-size:2.25rem;line-height:2.4375rem}}
.c-strat3__subtitle p a{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:inherit;color:inherit}
.c-strat3 .c-img-start3{margin-bottom:3.125rem}
.c-strat3 .c-img-start3__img-subtitle{margin-top:3.125rem}
.c-strat3 .c-img-start3__img-subtitle p{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:2.25rem;line-height:2.125rem;margin-bottom:0}
@media screen and (min-width:48em){.c-strat3 .c-img-start3__img-subtitle p{font-size:2.25rem;line-height:2.4375rem}}
.c-strat3 .c-img-start3__img-subtitle p a{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:inherit;color:inherit}
.c-strat3 .c-img-start3__first-element{margin-top:0}
.c-strat4{padding:4.6875rem 1.0625rem}
@media screen and (min-width:48em){.c-strat4{padding:4.6875rem 2.4375rem}}
@media screen and (min-width:64em){.c-strat4{padding:4.6875rem 0}}
.c-strat4__content-wrapper{margin:0 auto;padding:0 .75rem}
@media screen and (min-width:48em){.c-strat4__content-wrapper{padding:0}}
.c-strat4__title{font-size:.9375rem;line-height:1.25rem;letter-spacing:.125rem;margin:0 0 1.875rem}
.c-strat4__title,.c-strat4__title a{color:inherit;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif}
.c-strat4__title a{font-size:inherit}
.c-strat4__subtitle{color:inherit}
.c-strat4__subtitle p{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:2.0625rem;line-height:2.1875rem;margin-bottom:0}
@media screen and (min-width:48em){.c-strat4__subtitle p{font-size:2.25rem;line-height:2.4375rem}}
.c-strat4__subtitle p a{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:inherit;color:inherit}
.c-strat4__subtitle p strong{font-family:PlayfairDisplay-Bold,arial,sans-serif;font-weight:400}
.c-strat4__content{color:inherit;margin-top:1.875rem;text-align:left}
.c-strat4__content p{margin-bottom:0;font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;line-height:1.3125rem;font-size:.8125rem}
@media screen and (min-width:48em){.c-strat4__content p{font-size:1rem;line-height:1.5rem}}
.c-strat4__content p a{font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-size:inherit;color:inherit}
.c-strat4__content2{margin-top:1.875rem}
.c-strat4 .template_a{display:flex;flex-direction:row;flex-wrap:wrap}
.c-strat4 .template_a .c-strat4__title{order:1;width:100%}
@media screen and (min-width:64em){.c-strat4 .template_a .c-strat4__title{order:2}}
.c-strat4 .template_a .c-strat4__subtitle{order:2;width:100%}
@media screen and (min-width:64em){.c-strat4 .template_a .c-strat4__subtitle{order:3}}
@media screen and (min-width:64em){.c-strat4 .template_a .c-strat4__content-wrapper{padding:0 .3125rem}}
@media screen and (min-width:64em) and (max-width:74.9375em){.c-strat4 .template_a .c-strat4__image-container{margin-left:4.25rem}}
.c-strat4 .template_a .c-strat4__image-wrapper{order:3}
.c-strat4 .template_a .c-strat4__content{order:4;width:100%;margin-top:3.125rem}
@media screen and (min-width:64em){.c-strat4 .template_a .c-strat4__content{margin-top:1.875rem}}
.c-strat4 .template_a .img-teamplate-b{display:block;margin-top:3.125rem}
@media screen and (min-width:64em){.c-strat4 .template_a .img-teamplate-b{display:none}}
.c-strat4__video-holder .c-ratio-container--secondary:after{padding-bottom:55%}
.c-strat4 .template_b{display:flex;flex-direction:row;flex-wrap:wrap}
.c-strat4 .template_b .c-strat4__title{order:1;width:100%}
.c-strat4 .template_b .c-strat4__subtitle{order:2;width:100%}
.c-strat4 .template_b .c-strat4__image-wrapper{order:3;width:100%}
.c-strat4 .template_b .c-strat4__image,.c-strat4 .template_b .c-strat4__video-holder{margin-top:3.125rem}
.c-strat4 .template_b .c-strat4__content{order:4;width:100%;margin-top:3.125rem}
@media screen and (min-width:64em){.c-strat4 .template_b .c-strat4__content-wrapper{padding:0 .625rem}}
</style>